var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonCredentialStuffing = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("rect", { x: 3.913, y: 6, width: 40.087, height: 24, rx: 2, fill: fills.light }),
        React.createElement("path", { d: "M12.988 14.986a3.014 3.014 0 116.028 0 3.014 3.014 0 01-6.028 0zM10.842 20.091a3.01 3.01 0 012.13-.883h6.044a3.01 3.01 0 013.012 3.012v.605c0 .664-.54 1.203-1.203 1.203h-9.653a1.21 1.21 0 01-1.21-1.21v-.596c0-.8.318-1.566.88-2.13z", fill: fills.dark }),
        React.createElement("path", { d: "M26.674 20.617c0-.913.74-1.654 1.654-1.654h5.683a1.654 1.654 0 110 3.308h-5.683a1.657 1.657 0 01-1.654-1.654zM26.674 15.33c0-.913.74-1.655 1.654-1.655h7.216a1.654 1.654 0 110 3.308h-7.216a1.655 1.655 0 01-1.654-1.654z", fill: fills.base }),
        React.createElement("path", { d: "M22.55 26.873l-7.475 12.48A1.766 1.766 0 0016.585 42h14.95a1.764 1.764 0 001.509-2.648l-7.475-12.479a1.765 1.765 0 00-3.019 0z", fill: fills.dark }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.06 30.41c.55 0 .998.448.998 1v3.53a.999.999 0 01-1.997 0v-3.53c0-.552.447-1 .998-1zM23.06 38.47c0-.552.448-.999 1-.999h.01a.999.999 0 110 1.997h-.01a.999.999 0 01-1-.998z", fill: "#fff" })));
}, {
    name: identiconComponentName,
})({});
